import { scrollToIfNeeded } from "./scroll-to";
import easydropdown from "easydropdown-a11y";
import delegate from 'delegate-it';
import ajax from "./ajax";
import { generateQueryString } from "./util";
import cursor from "@/scripts/components/cursor";

export const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

export const handleFilterChange = (e, form, updateResultsCallback) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  if (typeof updateResultsCallback === 'function') {
    updateResultsCallback();
  } else {
    updateResults(form);
  }
};

export const handleFilterClear = (form, updateResultsCallback) => {
  form.reset();
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  if (typeof updateResultsCallback === 'function') {
    updateResultsCallback();
  } else {
    updateResults(form);
  }

  document.body.classList.remove("is-searching");
};

export const updateResults = async (form, setupExtraCallbacks) => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollToIfNeeded(pageContent, 24);
  } else {
    form.classList.remove("is-filtered");
  }

  cursor.reinitializeCursors();

  if (typeof setupExtraCallbacks === 'function') {
    setupExtraCallbacks();
  }
};

export const setupSlider = async (sliderContainer, options = {}) => {
  if (!sliderContainer) {
    return null;
  }

  const Splide = (await import('@splidejs/splide')).default;
  await import('@splidejs/splide/dist/css/splide.min.css');

  const numSlides = sliderContainer.querySelectorAll(".splide__slide").length;

  const defaultOptions = {
    perPage: 1,
    perMove: 1,
    arrows: false,
    drag: false,
    pagination: numSlides > 1 ? true : false,
    type: 'fade'
  };

  const sliderOptions = { ...defaultOptions, ...options };

  return new Splide(sliderContainer, sliderOptions).mount();
};

export const initializeFilterPage = (form, options = {}) => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    delegate(".filter-form select", "change", (e) => handleFilterChange(e, form, options.updateResultsCallback));
    delegate(".filter-form", "submit", (e) => handleFilterChange(e, form, options.updateResultsCallback));
    delegate(".filter-form-clear", "click", () => handleFilterClear(form, options.updateResultsCallback));
  }

  const sliderContainer = document.querySelector('.splide');
  if (sliderContainer) {
    setupSlider(sliderContainer, options.sliderOptions);
  }

  if (typeof options.setupExtraCallbacks === 'function') {
    options.setupExtraCallbacks();
  }
};
